import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "forms/forms.css";

const FormRow = ({ children, columns = 2 }) => (
  <div
    className={cx(styles.row, {
      [styles.columns_1]: columns === 1,
      [styles.columns_2]: columns === 2,
      [styles.columns_3]: columns === 3,
    })}
  >
    {children}
  </div>
);

FormRow.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.oneOf([1, 2, 3]),
};

export default FormRow;
